import React from 'react';

interface Props {
  /** Called once when the panel subtree throws, so the page can drop to the collapsed layout */
  onError: () => void;
  children: React.ReactNode;
}

interface State {
  failed: boolean;
}

/**
 * Wraps the lazy TradeTabPanel. The panel chunk is fetched by hash, so a tab
 * left open across a deploy can ask for a chunk that no longer exists. That
 * must degrade to the same place an old backend does (the collapsed strip with
 * its badges), never to a blank black block.
 */
class PanelErrorBoundary extends React.Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error) {
    console.warn('Trade panel failed to render; falling back to the collapsed layout:', error);
    this.props.onError();
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}

export default PanelErrorBoundary;
